import styles from './EntityPickerActions.module.scss';

import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  IReportPickerProps,
  ReportPicker,
} from '@work4all/components/lib/components/entity-picker/report-picker/ReportPicker';

import { reactRefSetter } from '@work4all/utils';

import { LabeledInput } from '../../containers/mask-overlays/locked-inputs';

interface ReportPickerFieldProps
  extends Omit<IReportPickerProps<false>, 'multiple'> {
  error?: string;
  name?: string;
}

export const ReportPickerField = React.forwardRef<
  HTMLDivElement,
  ReportPickerFieldProps
>(function ReportPickerField(props, ref) {
  const { error, ...pickerProps } = props;
  const { value, onChange } = pickerProps;

  const { t } = useTranslation();

  const wrapperRef = useRef<HTMLDivElement>(null);
  const popoverRef = useRef<EntityPickerPopover>(null);

  return (
    <div ref={reactRefSetter(wrapperRef, ref)}>
      <EntityPickerPopover
        ref={popoverRef}
        anchorEl={wrapperRef}
        picker={<ReportPicker {...pickerProps} multiple={false} />}
      >
        <LabeledInput
          value={value ? value?.note : ''}
          name={props.name}
          label={
            <>
              {!value && t('FIELDS.report')}
              {value && (
                <>
                  <span className={styles.primaryInfo}>
                    {t('FIELDS.report')} &nbsp;
                  </span>
                  <span className={styles.secondaryInfo}>{value?.note}</span>
                </>
              )}
            </>
          }
          error={error}
          onClear={() => {
            onChange(null);
          }}
        />
      </EntityPickerPopover>
    </div>
  );
});
